// Arabic strings for the demostaff stream — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until
// decision H-10.
import type { enDemostaff } from './en-demostaff.ts';
import type { Message } from './types.ts';

export const arDemostaff: { readonly [K in keyof typeof enDemostaff]: Message } = {
  // ------------------------------------------------------------ API (PD-818)
  'api.demoSandboxBusyStaff': 'شخص آخر يغيّر هذا في العرض التجريبي الآن — جرّب سجلاً آخر أو انتظر قليلاً.',
  // ------------------------------------------------------------ truthful staff and console copy in demo mode (PD-819)
  'demo.staff.saved': 'تم لك وحدك: لم يُحفظ أي شيء في هذا العرض التجريبي، ولا يرى التغيير إلا هذا المتصفح.',
  'demo.staff.draftSaved': 'المسودة محفوظة لك وحدك: لم يُحفظ أي شيء في هذا العرض التجريبي.',
  'demo.staff.published': 'الإصدار {number} ساري لك وحدك: لم يُحفظ أي شيء في هذا العرض التجريبي.',
  'demo.staff.versionSaved': 'تم لك وحدك (الإصدار {version} في هذا المتصفح): لم يُحفظ أي شيء في هذا العرض التجريبي.',
  'demo.staff.settingSaved': 'تغيّر لك وحدك في هذا العرض التجريبي: تعرض هذه الوحدة قيمتك، لكن لم يُحفظ أي شيء ويواصل النظام استخدام القيمة السابقة.',
  'demo.staff.hostNotTold': 'في هذا العرض التجريبي لا يُبلَّغ المضيف. ينتظر الزائر حتى تنجح كل الفحوص.',
};
